import QuickMessage from 'redhotpie-shared-lib/models/quickMessage';
import * as types from '../constants/actionTypes';
import quickMessageService from '../services/quickMessageService';
import { beginAjaxCall } from './ajaxStatusActions';

export function selectQuickMessageSuccess(data: QuickMessage) {
  return { type: types.SELECT_QUICK_MESSAGE_SUCCESS, data };
}
export function loadQuickMessageRequest() {
  return { type: types.LOAD_QUICK_MESSAGE_REQUEST };
}
export function loadQuickMessageFailed() {
  return { type: types.LOAD_QUICK_MESSAGE_FAILED };
}
export function loadQuickMessageSuccess(quickMessages: QuickMessage[]) {
  return { type: types.LOAD_QUICK_MESSAGE_SUCCESS, quickMessages };
}
export function addQuickMessageSuccess(quickMessage: QuickMessage) {
  return { type: types.ADD_QUICK_MESSAGE_SUCCESS, quickMessage };
}
export function updateQuickMessageSuccess(quickMessage: QuickMessage) {
  return { type: types.UPDATE_QUICK_MESSAGE_SUCCESS, quickMessage };
}
export function deleteQuickMessageSuccess(quickMessage: QuickMessage) {
  return { type: types.DELETE_QUICK_MESSAGE_SUCCESS, quickMessage };
}

export function loadQuickMessages() {
  return (dispatch: any) => {
    dispatch(loadQuickMessageRequest());
    return quickMessageService.loadAll().then(res => {
      if (res.success) {
        dispatch(loadQuickMessageSuccess(res.data.items));
      } else {
        dispatch(loadQuickMessageFailed());
        //  console.log("ERROR: quickMessageAction/loadQuickMessages", res.message);
      }
      return res;
    });
  };
}

export function addQuickMessage(params: QuickMessage) {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    return quickMessageService.addQuickMessage(params).then(res => {
      if (res.success) {
        dispatch(addQuickMessageSuccess(res.data));
      }

      return res;
    });
  };
}

export function updateQuickMessage(params: QuickMessage) {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    return quickMessageService.updateQuickMessage(params).then(res => {
      if (res.success) {
        dispatch(updateQuickMessageSuccess(res.data));
      }

      return res;
    });
  };
}

export function deleteQuickMessage(params: QuickMessage) {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    return quickMessageService.deleteQuickMessage(params).then(res => {
      if (res.success) {
        dispatch(deleteQuickMessageSuccess(res.data));
      }

      return res;
    });
  };
}
